import { c as _c } from "react/compiler-runtime";
// Which instance a record lives in (home merge): a small muted mono tag, shown only for records from a connected
// instance (the home's own records carry none). Styles: platform.css `.instance-tag`.
export function InstanceTag(t0) {
  const $ = _c(2);
  const {
    instance
  } = t0;
  if (!instance) {
    return null;
  }
  let t1;
  if ($[0] !== instance) {
    t1 = <span className="instance-tag mono" data-t="instance" title={instance}>@{instance}</span>;
    $[0] = instance;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}